export { GenerarNotaDeCreditoModalEdit } from "./generarnotasdecredito";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/notacredito/index.tsx